<template>
  <section class="ref-chapter-2">
    <div class="ref-chapter-2-content">
      <RefAnchorNav :section="2" />
      
      <v-container  class="px-sm-8 py-0 pa-md-0">
        <v-row align="start" justify="space-between" no-gutters class="mb-12 mb-md-16">
          <v-col cols="12" md="3">
            <p class="text-section text--fes-magenta mb-4 mb-md-0">
              Videos
            </p>
          </v-col>

          <v-col cols="12" md="8">
            <div class="reference-list">
              <div v-for="(ref, i) in refListVideos" :key="'ref-videos' + i" class="mb-8">
                <p class="text-body text--fes-blue mb-4">
                  {{ ref.item }} 
                </p> 
                <iframe class="reference-video" :src="ref.embed" />
              </div>            
            </div>                              
          </v-col>
        </v-row>  
                
        <v-row align="start" justify="space-between" no-gutters>
          <v-col cols="12" md="3">
            <p class="text-section text--fes-magenta mb-4 mb-md-0">
              Articles and publications
            </p>
          </v-col>

          <v-col cols="12" md="8">
            <div class="reference-list mb-12">
              <div class="mb-6 mb-md-8" v-for="(ref, i) in refList" :key="i + '-ref-further-;ist' ">
                <v-row align="start">
                  <v-col cols="4" md="3">
                    <img :src="require('@/assets/references/' + `${ref.image}`)" width="100%"/> 
                  </v-col>

                  <v-col cols="8" md="9">
                    <p class="text-body-xs text--fes-blue mb-3">{{ ref.author }}</p>
                    <p class="text-body text--fes-blue mb-4 font-weight-bold">
                      <a :href="ref.link" target="_blank">{{ ref.title }}</a>
                    </p>
                    <p class="text-body-xs text--fes-blue mb-0">{{ ref.date }}</p>
                    <div v-if="ref.thumbnail_1" class="mt-4">
                      <a :href="ref.link_thumbnail" target="_blank">
                        <img v-if="ref.thumbnail_1" :src="require('@/assets/references/thumbnail/' + `${ref.thumbnail_1}`)" width="25%" class="mr-4" />
                      </a>
                      <a :href="ref.link_thumbnail" target="_blank">                      
                        <img v-if="ref.thumbnail_2" :src="require('@/assets/references/thumbnail/' + `${ref.thumbnail_2}`)" width="25%" class="mr-4" />
                      </a>
                      <a :href="ref.link_thumbnail" target="_blank">                      
                        <img v-if="ref.thumbnail_3" :src="require('@/assets/references/thumbnail/' + `${ref.thumbnail_3}`)" width="25%"  />
                      </a>
                    </div>
                  </v-col>                
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>      
      </v-container>
    </div>      
  </section>  
</template>

<script>
import RefAnchorNav from '@/components/layout/RefAnchorNav'

export default {
  name: 'RefChapter2',
  components: {
    RefAnchorNav
  },
  data() {
    return {
      refListFurtherReading: [
        {
          item: 'Aminjonov, Farkhod (2016). Afghanistan’s energy security: Tracing central Asian countries’ contribution. Kabul: FES Afghanistan Office.',
          link: 'https://asia.fes.de/news/afghanistans-energy-security-tracing-central-asian-countries-contribution/'
        },
        {
          item: 'Dang, Thuy Duong (2019). The greenest kind of growth is degrowth. FES-Asia, 25 March.', 
          link: 'https://asia.fes.de/news/the-greenest-kind-of-growth-is-degrowth'
        },
        {
          item: 'FES-Asia editorial team (2021). Revisit our regional conference on social-ecological transformation in Asian cities. FES-Asia, 15 September.', 
          link: 'https://asia.fes.de/news/social-ecological-transformation-conference'
        },
        {
          item: 'FES Climate & Energy Project in Asia (2020). Revisit our web discussions on gender and energy. 4 November.', 
          link: 'https://asia.fes.de/news/gender-energy-keynotes/'
        },
        {
          item: 'FES Indonesia (2018). FES contributes to the German-Indonesian exchange on how to prepare for the fourth industrial revolution. FES-Asia, 4 July.',
          link: 'https://asia.fes.de/news/fes-contributes-to-the-german-indonesian-exchange-on-how-to-prepare-for-the-fourth-industrial-revolution'
        },
        {
          item: 'FES Korea (2017). Transforming cities for decent work. FES-Asia, 20 September.',
          link: 'https://www.youtube.com/watch?v=BwZz6K5ZM48'
        },
        {
          item: 'Friedrich-Ebert-Stiftung Global (2017). The pathway to a socially just energy transition in Asia | FES Asia. YouTube video. 9 October.',
          link: 'https://www.youtube.com/watch?v=u8MxcO6raLM&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=42'
        },
        {
          item: 'Friedrich-Ebert-Stiftung Global (2018). The social city—Enabling an urban transformation in Asia. YouTube video. 10 December.',
          link: 'https://youtu.be/Jf0Srv3F4qQ'
        },   
        {
          item: 'Friedrich-Ebert-Stiftung Global (2019). Alliances for gender just climate action | FES Asia. YouTube video. 31 May.',
          link: 'https://youtu.be/3q30AaMcBqI'
        },
        {
          item: 'Friedrich-Ebert-Stiftung Global (2021). Social-ecological transformation in Asian cities | FES Asia. YouTube video. 4 August.',
          link: 'https://youtu.be/2IIljNlOpUQ'
        },
        {
          item: 'Fiedler, Anna Julia (2020). Who gets to stay at home? Social distancing in Asia’s megacities. FES-Asia, 24 April.',
          link: 'https://asia.fes.de/news/who-gets-to-stay-at-home-social-distancing-in-asias-megacities/'
        },
        {
          item: 'Friedrich-Ebert-Stiftung Vietnam (2017). A socially just energy transition involves everybody. 12 October.',
          link: 'https://asia.fes.de/news/a-socially-just-energy-transition-involves-everybody/'
        },
        {
          item: 'Fortaleza, Wilson, and others (2016). Getting TheRE: Getting through the humps and red lights that hinder the advance of green energy. Policy paper 02. Pasig City, Philippines: Friedrich-Ebert-Stiftung – Philippine Office.',
          link: 'http://library.fes.de/pdf-files/bueros/philippinen/13975.pdf'
        },
        {
          item: 'Grassi, Sergio (2019). Building liveable, social cities for the economy of tomorrow in Asia and Germany. FES-Asia, 28 October.',
          link: 'https://asia.fes.de/news/building-liveable-social-cities-for-the-economy-of-tomorrow-in-asia-and-germany/'
        },
        {
          item: 'Hiltl, Melissa (2021). Women and climate change: Initializing gender-sensitive perspectives for South-East Asia.” FES-Asia, 5 November.',
          link: 'https://asia.fes.de/news/women-and-climate-change-initializing-gender-sensitive-perspectives-for-south-east-asia/'
        },
        {
          item: 'Kulshreshtha, Mandvi (2019). Climate-conscious urbanisation can lead to sustainable future. FES-Asia, 26 July.',
          link: 'https://india.fes.de/e/climate-conscious-urbanisation-can-lead-to-sustainable-future'
        },                                                                                    
        {
          item: 'Kulshreshtha, Mandvi (2020). Could city’s health be everyone’s wealth? FES-Asia, 15 September.',
          link: 'https://india.fes.de/e/could-citys-health-be-everyones-wealth/'
        },
        {
          item: 'Neefjes, Koos, and Dang Thi Thu Hoai (2017). Towards a socially just energy transition in Vietnam. Hanoi: Friedrich-Ebert-Stiftung Vietnam Office.',
          link: 'https://asia.fes.de/news/towards-a-socially-just-energy-transition-in-viet-nam'
        },                
        {
          item: 'Nguyen, Hoang Ngan (2018). Building alliances for a just energy transition in Asia. FES-Asia, 24 October.',
          link: 'https://asia.fes.de/news/building-alliances-for-a-just-energy-transition-in-asia'
        },
        {
          item: 'Nicolaisen, Franziska (2020). The case for social cities. FES-Asia, 31 October.',
          link: 'https://asia.fes.de/news/world-cities-day/'
        },
        {
          item: 'Padawangi, Rita (2018). The social city: Aspiration of an urban transformation in Asia. Jakarta: Friedrich-Ebert-Stiftung Indonesia Office.',
          link: 'https://asia.fes.de/news/the-social-city-aspiration-of-an-urban-transformation-in-asia'
        },
        {
          item: 'Panaligan, Riedo (2021). Op-ed: Asian Development Bank should close its doors to all dirty energy. FES-Asia, 26 May.',
          link: 'https://asia.fes.de/news/adb-energy-policy'
        },                
        {
          item: 'Randolph, Gregory (2018). Linking the global urban and jobs agendas: Towards a policy framework for job-rich urbanization. FES-Asia, 5 March.',
          link: 'https://asia.fes.de/news/linking-the-global-urban-and-jobs-agendas-toward-a-policy-framework-for-job-rich-urbanization'
        },
        {
          item: 'Ringot, Yannick (2017). Building a low-carbon city: Experiences from China and Germany.” FES-Asia, 14 July.',
          link: 'https://asia.fes.de/news/building-a-low-carbon-city-experiences-from-china-and-germany'
        },   
        {
          item: 'Sartori, Silvia (2020). Further steps are needed to ensure a gender-just energy transition. FES-Asia, 2 November.',
          link: 'https://connect.fes.de/people/further-steps-are-needed-to-ensure-a-gender-just-energy-transition/.'
        },                
        {
          item: 'Schreurs, Miranda, and Julia Balanowski (2017). Promoting socially and economically just energy transformations in Asia. Hanoi: Friedrich-Ebert-Stiftung Vietnam Office.',
          link: 'https://asia.fes.de/news/promoting-socially-and-economically-just-energy-transformations-in-asia'
        },
        {
          item: 'Shopova, Mila (2018). Social urban policy must fight unemployment. FES-Asia, 19 March.',
          link: 'https://asia.fes.de/news/social-urban-policy-must-fight-unemployment/'
        },     
        {
          item: 'Verzola, Roberto S. (2016). Crossing over: The energy transition to renewable electricity. 2nd edition. Pasig City: Friedrich-Ebert-Stiftung Philippines Office.',
          link: 'http://library.fes.de/pdf-files/bueros/philippinen/13974.pdf'
        }, 
        {
          item: 'Woltersdorf, Adrienne (2019). How to put the “social” into smart cities? FES-Asia, 15 January.',
          link: 'https://asia.fes.de/news/how-to-put-the-social-into-smart-cities'
        }, 
        {
          item: 'Zhang, Junjie, and others (2018). Achieving a socially equitable energy transition in China. Shanghai: FES Shanghai Representative Office.',
          link: 'https://asia.fes.de/news/achieving-a-socially-equitable-energy-transition-in-china'
        }                                                 
      ],
      refListVideos: [
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2019). Alliances for gender just climate action | FES Asia. YouTube video. 31 May. ', 
          link: 'https://www.youtube.com/watch?v=3q30AaMcBqI&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=19',
          embed: 'https://www.youtube.com/embed/3q30AaMcBqI'
        },
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2019). Building a social city: An urbanist’s call from Asia and Germany | FES Asia. YouTube video. 23 October. ', 
          link: 'https://www.youtube.com/watch?v=4eHuJtoQKvc&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=13',
          embed: 'https://www.youtube.com/embed/4eHuJtoQKvc'
        },
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2018). From Hanoi to Katowice: We must step up climate action targets | FES Vietnam. YouTube video. 29 October. ', 
          link: 'https://www.youtube.com/watch?v=4J7wWLOc9rQ&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=25',
          embed: 'https://www.youtube.com/embed/4J7wWLOc9rQ'          
        },
        {
          item: 'Friedrich-Ebert-Stiftung Global (2022). RETURN TO REPAIR | A film on the repair economy in India. YouTube video. 4 March.',
          link: 'https://www.youtube.com/watch?v=AHsb-TGmpr4&list=PLziW1-CX6aaSMi8xNDx8ZF7y_JK2LoxV4&index=4',
          embed: 'https://www.youtube.com/embed/AHsb-TGmpr4'
        },
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2017). The pathway to a socially just energy transition in Asia | FES Asia. YouTube video. 9 October. ', 
          link: 'https://www.youtube.com/watch?v=u8MxcO6raLM&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=42',
          embed: 'https://www.youtube.com/embed/u8MxcO6raLM'
        },
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2018). The social city—Aspiration of an urban transformation in Asia | Climate and Energy | FES Asia. YouTube video. 10 December. ', 
          link: 'https://www.youtube.com/watch?v=Jf0Srv3F4qQ&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=22',
          embed: 'https://www.youtube.com/embed/Jf0Srv3F4qQ'
        },
        { 
          item: 'Friedrich-Ebert-Stiftung Global (2020). Challenges for sustainable urban development in Vietnam | FES Asia. YouTube video. 3 December. ', 
          link: 'https://www.youtube.com/watch?v=IJMSqLYqePk&feature=youtu.be',
          embed: 'https://www.youtube.com/embed/IJMSqLYqePk'
        },  
        {
          item: 'Hanoi Ad hoc (2022). [Gia Lam Train Factory] Ideology on Rail. YouTube video. 27 April.',
          link: 'https://www.youtube.com/watch?v=fSj9gw_Bves',
          embed: 'https://www.youtube.com/embed/fSj9gw_Bves'
        }     
      ],
      refList: [
      {
        "id": 1,
        "title": "Afghanistan’s energy security: Tracing central Asian countries’ contribution",
        "link": "https://asia.fes.de/news/afghanistans-energy-security-tracing-central-asian-countries-contribution/.",
        "author": "Aminjonov, Farkhod",
        "date": 2016,
        "image": "01-afghanistan-energy-security.jpg"
      },
      {
        "id": 2,
        "title": "The greenest kind of growth is degrowth",
        "link": "https://asia.fes.de/news/the-greenest-kind-of-growth-is-degrowth",
        "author": "Dang, Thuy Duong",
        "date": 2019,
        "image": "02-the-greenest-kind.jpg"
      },
      {
        "id": 3,
        "title": "Revisit our regional conference on social-ecological transformation in Asian cities",
        "link": "https://asia.fes.de/news/social-ecological-transformation-conference",
        "author": "FES-Asia editorial team",
        "date": 2021,
        "image": "03-revisit-our-regional-conference.jpg",
        "thumbnail_1": "set-conference-day1-infographic.png",
        "thumbnail_2": "set-conference-day2-infographic.png",
        "thumbnail_3": "set-conference-day3-infographic.png",   
        "link_thumbnail": "https://asia.fes.de/news/social-ecological-transformation-conference"
      },
      {
        "id": '3a',
        "title": "Pathways towards a social-ecological transformation in Asian cities",
        "link": "https://asia.fes.de/news/pathways-towards-a-social-ecological-transformation-in-asian-cities",
        "author": "FES Climate & Energy Project in Asia",
        "date": 2020,
        "image": "32-pathways-towards-a-social-ecological-transformation-in-asian-cities.png",
        "thumbnail_1": "pathway-towards-set-in-asian-cities-infographic.png",
        "link_thumbnail": "https://asia.fes.de/news/pathways-towards-a-social-ecological-transformation-in-asian-cities"             
      },      
      {
        "id": 4,
        "title": "Revisit our web discussions on gender and energy",
        "link": "https://asia.fes.de/news/gender-energy-keynotes/",
        "author": "FES Climate & Energy Project in Asia",
        "date": 2020,
        "image": "04-revisit-our-web-discussions.jpg"
      },
      {
        "id": 6,
        "title": "FES contributes to the German-Indonesian exchange on how to prepare for the fourth industrial revolution",
        "link": "https://asia.fes.de/news/fes-contributes-to-the-german-indonesian-exchange-on-how-to-prepare-for-the-fourth-industrial-revolution",
        "author": "FES Indonesia",
        "date": 2018,
        "image": "06-fes-contributes.jpg"
      },
      {
        "id": 7,
        "title": "Transforming cities for decent work",
        "link": "https://www.youtube.com/watch?v=BwZz6K5ZM48",
        "author": "FES Korea",
        "date": 2017,
        "image": "07-transforming-cities-for-decent.jpg"
      },
      {
        "id": 8,
        "title": "The pathway to a socially just energy transition in Asia",
        "link": "https://www.youtube.com/watch?v=u8MxcO6raLM&list=PLI9CwYW3a-6VveB5lnRvb9TksOKYltbGh&index=42",
        "author": "Friedrich-Ebert-Stiftung Global",
        "date": 2017,
        "image": "08-the-pathway-to-a-socially.png"
      },
      {
        "id": 9,
        "title": "The social city—Enabling an urban transformation in Asia",
        "link": "https://youtu.be/Jf0Srv3F4qQ",
        "author": "Friedrich-Ebert-Stiftung Global",
        "date": 2018,
        "image": "09-the-social-city-enabling.png"
      },
      {
        "id": 10,
        "title": "Alliances for gender just climate action",
        "link": "https://youtu.be/3q30AaMcBqI",
        "author": "Friedrich-Ebert-Stiftung Global",
        "date": 2019,
        "image": "10-alliances-for-gender-just.png"
      },
      {
        "id": 11,
        "title": "Social-ecological transformation in Asian cities",
        "link": "https://youtu.be/2IIljNlOpUQ",
        "author": "Friedrich-Ebert-Stiftung Global",
        "date": 2021,
        "image": "11-social-ecological-transformation-in.png"
      },
      {
        "id": 12,
        "title": "Who gets to stay at home? Social distancing in Asia’s megacities",
        "link": "https://asia.fes.de/news/who-gets-to-stay-at-home-social-distancing-in-asias-megacities/",
        "author": "Fiedler, Anna Julia",
        "date": 2020,
        "image": "12-who-gets-to-stay.jpg"
      },
      {
        "id": 13,
        "title": "A socially just energy transition involves everybody",
        "link": "https://asia.fes.de/news/a-socially-just-energy-transition-involves-everybody/",
        "author": "Friedrich-Ebert-Stiftung Vietnam",
        "date": 2017,
        "image": "13-a-socially-just-energy.jpg"
      },
      {
        "id": 14,
        "title": "Getting TheRE: Getting through the humps and red lights that hinder the advance of green energy",
        "link": "http://library.fes.de/pdf-files/bueros/philippinen/13975.pdf",
        "author": "Fortaleza, Wilson, and others",
        "date": 2016,
        "image": "14-getting-there.png"
      },
      {
        "id": 15,
        "title": "Building liveable, social cities for the economy of tomorrow in Asia and Germany",
        "link": "https://asia.fes.de/news/building-liveable-social-cities-for-the-economy-of-tomorrow-in-asia-and-germany/",
        "author": "Grassi, Sergio",
        "date": 2019,
        "image": "15-building-liveable-social.jpg"
      },
      {
        "id": 16,
        "title": "Women and climate change: Initializing gender-sensitive perspectives for South-East Asia",
        "link": "https://asia.fes.de/news/women-and-climate-change-initializing-gender-sensitive-perspectives-for-south-east-asia/",
        "author": "Hiltl, Melissa",
        "date": 2021,
        "image": "16-women-and-climate.jpg"
      },
      {
        "id": 17,
        "title": "Climate-conscious urbanisation can lead to sustainable future",
        "link": "https://india.fes.de/e/climate-conscious-urbanisation-can-lead-to-sustainable-future",
        "author": "Kulshreshtha, Mandvi",
        "date": 2019,
        "image": "17-climate-conscious-urbanisation.jpg"
      },
      {
        "id": 18,
        "title": "Could city’s health be everyone’s wealth",
        "link": "https://india.fes.de/e/could-citys-health-be-everyones-wealth/",
        "author": "Kulshreshtha, Mandvi",
        "date": 2020,
        "image": "18-could-citys-health.png"
      },
      {
        "id": 19,
        "title": "Towards a socially just energy transition in Viet Nam",
        "link": "https://asia.fes.de/news/towards-a-socially-just-energy-transition-in-viet-nam",
        "author": "Neefjes, Koos; Dang, Thi Thu Hoai ",
        "date": 2017,
        "image": "19-towards-a-socially-just.jpg"
      },
      {
        "id": 20,
        "title": "Building alliances for a just energy transition in Asia",
        "link": "https://asia.fes.de/news/building-alliances-for-a-just-energy-transition-in-asia",
        "author": "Nguyen, Hoang Ngan ",
        "date": 2018,
        "image": "20-building-alliances.jpg"
      },
      {
        "id": 21,
        "title": "The case for social cities",
        "link": "https://asia.fes.de/news/world-cities-day/",
        "author": "Nicolaisen, Franziska",
        "date": 2020,
        "image": "21-the-case-for-social-cities.jpg"
      },
      {
        "id": 22,
        "title": "The social city: Aspiration of an urban transformation in Asia",
        "link": "https://asia.fes.de/news/the-social-city-aspiration-of-an-urban-transformation-in-asia",
        "author": "Padawangi, Rita",
        "date": 2018,
        "image": "22-the-social-city-aspiration.jpg"
      },
      {
        "id": 23,
        "title": "Op-ed: Asian Development Bank should close its doors to all dirty energy",
        "link": "https://asia.fes.de/news/adb-energy-policy",
        "author": "Panaligan, Riedo",
        "date": 2021,
        "image": "23-op-ed-asian-development.jpg"
      },
      {
        "id": 24,
        "title": "Linking the global urban and jobs agendas: Towards a policy framework for job-rich urbanization",
        "link": "https://asia.fes.de/news/linking-the-global-urban-and-jobs-agendas-toward-a-policy-framework-for-job-rich-urbanization",
        "author": "Randolph, Gregory",
        "date": 2018,
        "image": "24-linking-the-global-urban.jpg"
      },
      {
        "id": 25,
        "title": "Building a low-carbon city: Experiences from China and Germany",
        "link": "https://asia.fes.de/news/building-a-low-carbon-city-experiences-from-china-and-germany",
        "author": "Ringot, Yannick",
        "date": 2017,
        "image": "25-building-a-low-carbon.jpg"
      },
      {
        "id": 26,
        "title": "Further steps are needed to ensure a gender-just energy transition",
        "link": "https://connect.fes.de/people/further-steps-are-needed-to-ensure-a-gender-just-energy-transition/",
        "author": "Sartori, Silvia",
        "date": 2020,
        "image": "26-further-steps-are-needed.jpg"
      },
      {
        "id": 27,
        "title": "Promoting socially and economically just energy transformations in Asia",
        "link": "https://asia.fes.de/news/promoting-socially-and-economically-just-energy-transformations-in-asia",
        "author": "Schreurs, Miranda; Balanowski, Julia",
        "date": 2017,
        "image": "27-promoting-socially.jpg"
      },
      {
        "id": 28,
        "title": "Social urban policy must fight unemployment",
        "link": "https://asia.fes.de/news/social-urban-policy-must-fight-unemployment/",
        "author": "Shopova, Mila",
        "date": 2018,
        "image": "28-social-urban-policy.jpg"
      },
      {
        "id": 29,
        "title": "Crossing over: The energy transition to renewable electricity",
        "link": "http://library.fes.de/pdf-files/bueros/philippinen/13974.pdf",
        "author": "Verzola, Roberto S.",
        "date": 2016,
        "image": "29-crossing-over-the-energy.png"
      },
      {
        "id": 30,
        "title": "How to put the “social” into smart cities?",
        "link": "https://asia.fes.de/news/how-to-put-the-social-into-smart-cities",
        "author": "Woltersdorf, Adrienne",
        "date": 2019,
        "image": "30-how-to-put-the-social.jpg"
      },
      {
        "id": 31,
        "title": "Achieving a socially equitable energy transition in China",
        "link": "https://asia.fes.de/news/achieving-a-socially-equitable-energy-transition-in-china",
        "author": "Zhang, Junjie, and others",
        "date": 2018,
        "image": "31-achieving-a-socially-equitable.jpg"
      },
      {
        "id": 32,
        "title": "Summary: Designing mobility for liveable and social cities",
        "link": "https://asia.fes.de/news/mobility-in-asia",
        "author": "Kucz, Ingo; Naji, Sascha",
        "date": 2022,
        "image": "Summary_mobility_studies_frontcover.jpg"
      },
      {
        "id": 33,
        "title": "Metro Manila: Designing mobility for liveable and social cities",
        "link": "https://asia.fes.de/news/manila-mobility",
        "author": "Esguerra, Jude",
        "date": 2022,
        "image": "Manila Mobility Cover_Page_01.png"
      },
      {
        "id": 34,
        "title": "Chennai’s pursuit towards a green and inclusive city",
        "link": "https://asia.fes.de/news/resilient-chennai-photo-essay",
        "author": "FES-Asia editorial team",
        "date": 2022,
        "image": "Chennai.png"
      },
      {
        "id": 35,
        "title": "Metro Manila in the new normal: A call for access and mobility",
        "link": "https://asia.fes.de/news/manila-mobility-photo-essay",
        "author": "FES-Asia editorial team",
        "date": 2022,
        "image": "Metro Manila.jpg"
      }
      ]       
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-chapter-2 {
  scroll-margin-top: 70px;  

  .ref-chapter-2-content {
    padding: 96px 0;
    background: #ECF6F9;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 48px 4px;
    }

    .reference-list {
      p:last-child {
        margin-bottom: 0 !important;
      }

      iframe.reference-video {
        width: 560px;
        height: 315px;

        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          height: 225px;
          width: 100%;
        }
      }
    }    
    
    .reading-card:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>